// src/api/index.js

import axios from "axios";
import { createAppTransport } from "@1823-partners/core";

const api = createAppTransport({ axios, appName: "alm" });

// 1) Basic asset class data (zspread, mkt_px, etc)
export async function fetchAssetClassData(asof) {
  const response = await api.get(`/assetClasses?asof=${asof}`);
  return response.data;
}

// 2) Metrics per region/tenor
export async function fetchMetrics(
  asof,
  updatedWeights,
  securitySelection,
  extra_prem = 0,
  updatedSpreads = null,
  updatedYields = null,
  reinvestmentYield = 0
) {
  const requestBody = { asof, updatedWeights, securitySelection, extra_prem, reinvestmentYield };

  if (updatedSpreads !== null) {
    requestBody.updatedSpreads = updatedSpreads;
  }
  if (updatedYields !== null) {
    requestBody.updatedYields = updatedYields;
  }

  const response = await api.post("/metrics", requestBody);
  return response.data;
}

// 3) ALM graph data
export async function fetchAlmGraphData(
  asof,
  updatedWeights,
  securitySelection,
  extra_prem = 0,
  updatedSpreads = null,
  updatedYields = null,
  reinvestmentYield = 0
) {
  const requestBody = { asof, updatedWeights, securitySelection, extra_prem, reinvestmentYield };

  if (updatedSpreads !== null) {
    requestBody.updatedSpreads = updatedSpreads;
  }
  if (updatedYields !== null) {
    requestBody.updatedYields = updatedYields;
  }

  const response = await api.post("/almGraph", requestBody);
  return response.data;
}

// 4) Assets vs BV graph data
export async function fetchAssetsBvData(
  asof,
  updatedWeights,
  securitySelection,
  extra_prem = 0,
  updatedSpreads = null,
  updatedYields = null,
  reinvestmentYield = 0
) {
  const requestBody = { asof, updatedWeights, securitySelection, extra_prem, reinvestmentYield };

  if (updatedSpreads !== null) {
    requestBody.updatedSpreads = updatedSpreads;
  }
  if (updatedYields !== null) {
    requestBody.updatedYields = updatedYields;
  }

  const response = await api.post("/assetsBv", requestBody);
  return response.data;
}

export async function fetchWeights(asof, region, tenor) {
  const response = await api.get("/weights", { params: { asof, region, tenor } });
  return response.data;
}

export async function fetchAvailableDates() {
  const response = await api.get("/availableDates");
  return response.data;
}

export async function fetchAllWeights(asof) {
  const response = await api.get("/allWeights", { params: { asof } });
  return response.data;
}

export async function fetchRatings() {
  const response = await api.get("/ratings");
  let normalizedData = response?.data;
  if (typeof normalizedData === "string") {
    try {
      let sanitized = normalizedData;
      sanitized = sanitized.replace(/(:\s*)NaN\b/g, "$1null");
      sanitized = sanitized.replace(/(\[\s*)NaN\b/g, "$1null");
      sanitized = sanitized.replace(/(,\s*)NaN\b/g, "$1null");
      normalizedData = JSON.parse(sanitized);
    } catch (parseError) {
      normalizedData = response?.data;
    }
  }
  return normalizedData;
}

export async function saveRatings(user, ratingsData) {
  const response = await api.post("/ratings", {
    user,
    data: ratingsData,
  });
  return response.data;
}

export default api;
